import '../../../../../FE/src/assets/javascripts/libs/slick.js';


export default class Carousel {
  constructor(el) {
    this.$this = $(el);
    this.$carousel = this.$this.find('.gravity-full-width-image-carousel__wrapper');
    this.$prevArrow = this.$this.find('.gravity-full-width-image-carousel__control-button--prev');
    this.$nextArrow = this.$this.find('.gravity-full-width-image-carousel__control-button--next');

  }

  init() {
    this.addCarousel();
  }

  addCarousel() {
    this.$carousel.slick({
        rows: 0,
        slide: '.gravity-full-width-image-carousel__slide',
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false,
        infinite: false,
        arrows: true,
        autoplay: false,
        nextArrow: this.$nextArrow,
        prevArrow: this.$prevArrow,
    });
  }
}

$('.gravity-full-width-image-carousel').each((_index, el) => {
  new Carousel(el).init();
});
